<template>
	<v-expansion-panels v-model="activePanel" tile class="first-panel">
		<stepper-panel-sale :activePanel="activePanel" :panelKey="0" :isDisabled="disableAllPanels || getPanels.panel1disabled">
			<template v-slot:header> {{ $t('steppersale.steponetext') }} </template>
			<template v-slot:content>
				<selector-ticket-type />
				<v-row class="d-flex justify-end px-5">
					<v-btn color="info" :disabled="getTicketsToSale.length < 1" @click="handleNextStep">
						<span class="mr-2 pl-2"> {{ $t('steppersale.nextbutton') }} </span>
					</v-btn>
				</v-row>
			</template>
		</stepper-panel-sale>

		<stepper-panel-sale :activePanel="activePanel" :panelKey="1" :isDisabled="disableAllPanels || activePanel < 1 || getPanels.panel2disabled">
			<template v-slot:header> {{ $t('steppersale.steptwotext') }} </template>
			<template v-slot:content>
				<login v-if="loginIsNeeded" @loginSuccessful="handleLoginSuccesfull" />
				<dynamic-event-form v-if="!loginIsNeeded" @selectedBuyer="handleSelectedBuyer" @handleNextStep="handleNextStep" />
			</template>
		</stepper-panel-sale>
		<stepper-panel-sale
			:activePanel="activePanel"
			:panelKey="2"
			:isDisabled="disableAllPanels || activePanel === undefined || activePanel < 2 || isFree || getPanels.panel3disabled"
		>
			<template v-slot:header> {{ $t('steppersale.stepthreetext') }} </template>
			<template v-slot:content>
				<v-overlay :value="paymentLoading" :absolute="true">
					<v-progress-circular indeterminate size="64"></v-progress-circular>
				</v-overlay>

				<payment-manager @handlePayment="handlePayment" />

				<div>
					<form
						id="formulariodepago"
						name="formulariodepago"
						class="form-signin"
						role="form"
						:action="paymentForm.URL"
						method="post"
						ref="formulariodepago"
					>
						<input type="hidden" name="value(PARAMETERS)" :value="paymentForm.PARAMETERS" />
						<input type="hidden" name="value(SIGNATURE)" :value="paymentForm.SIGNATURE" />
						<input type="hidden" name="value(IDPASARELA)" :value="paymentForm.IDPASARELA" />
						<input type="hidden" name="value(IDPIN)" :value="paymentForm.IDPIN" />
						<input type="hidden" name="value(CANT)" :value="paymentForm.CANT" />
						<input type="hidden" name="value(DESCRIP)" :value="paymentForm.DESCRIP" />
						<input type="hidden" name="value(EVENTO)" :value="paymentForm.EVENTO" />
						<input type="hidden" name="value(ANYO)" :value="paymentForm.ANYO" />
					</form>
				</div>
			</template>
		</stepper-panel-sale>
		<stepper-panel-sale
			:activePanel="activePanel"
			:panelKey="3"
			:isDisabled="disableAllPanels || activePanel === undefined || activePanel < 3 || getPanels.panel4disabled"
			:isLastPanel="true"
			class="confirm-order"
		>
			<template v-slot:header> {{ $t('steppersale.stepfourtext') }} </template>
			<template v-slot:content>
				<order-confirmation />
			</template>
		</stepper-panel-sale>
	</v-expansion-panels>
</template>

<script>
import StepperPanelSale from './StepperPanelSale.vue';
import SelectorTicketType from './selectorTicketType/SelectorTicketType';
import DynamicEventForm from './eventForm/DynamicEventForm.vue';
import OrderConfirmation from './orderConfirmation/OrderConfirmation.vue';
import PaymentManager from './payment/PaymentManager.vue';
import Login from '../login/Login.vue';
import { mapGetters, mapActions } from 'vuex';
import api from '../../api/api';

export default {
	components: {
		'stepper-panel-sale': StepperPanelSale,
		'selector-ticket-type': SelectorTicketType,
		'dynamic-event-form': DynamicEventForm,
		'order-confirmation': OrderConfirmation,
		'payment-manager': PaymentManager,
		login: Login
	},
	data() {
		return {
			orderResult: {},
			activePanel: 0,
			disableAllPanels: false,
			loginIsNeeded: false,
			selectedBuyer: null,
			paymentLoading: false,
			paymentForm: {
				URL: null,
				PARAMETERS: null,
				SIGNATURE: null,
				IDPASARELA: null,
				IDPIN: null,
				CANT: null,
				DESCRIP: null,
				EVENTO: null,
				ANYO: null
			}
		};
	},
	watch: {
		activePanel(val) {
			val === 1 && this.handlerPanelDynamicForm();

			val === 2 && this.isFree && this.handleFreeTickets();
		},
		getActivePanel: {
			handler(val) {
				//from vuex
				if (val) {
					this.activePanel = val;
				}
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(['SET_ORDER_RESULT', 'SET_PANEL_DISABLED']),
		prepareProccesPaymentBody() {
			const ticketConfigurations = this.getTicketsToSale.map((conf) => {
				const oneForm = conf.ticketType.oneFormPerSale;
				const selectedForm = conf.tickets[0].form;

				const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

				const tickets = conf.tickets.map((ticket) => {
					const form = !oneForm ? ticket.form : deepClone(selectedForm);
					return { ...ticket, form };
				});
				console.log(conf);
				return {
					ticketType: {
						id: conf.ticketType.id,
						price: conf.ticketType.price,
						vatPercentage: conf.ticketType.vatPercentage,
						oneFormPerSale: conf.ticketType.oneFormPerSale
					},
					tickets,
					promocode: conf.promocode,
					promocodeUses: conf.promocodeUses
				};
			});
			let visitorId;
			if (this.loginRequired) {
				if (!this.getLogin.email) {
					//no pasrará ya que al hacer logout se reinicia la venta...
					this.$toast.error(this.$t('steppersale.loginneeded'));
					return this.$t('steppersale.loginneeded');
				}

				visitorId = this.getLogin.email;
			} else {
				visitorId = this.selectedBuyer; //es el que el usuario selecciona !
			}

			const body = {
				tepId: this.getFirstSaleData.tepId,
				eventId: this.getFirstSaleData.eventId,
				includeData: this.getFirstSaleData.includeData,
				receiveInformation: this.getFirstSaleData.receiveInformation,
				dataToThirdParties: this.getFirstSaleData.dataToThirdParties,
				visitorId,
				ticketConfigurations,
				campaignHash:this.$route.params.hash,
				invitadorHash:this.$route.params.hash_invitador
			};
			return body;
		},
		handleFreeTickets() {
			this.paymentLoading = true;
			const body = this.prepareProccesPaymentBody();
			api.externalSale
				.performSale({ body })
				.then((res) => {
					this.SET_ORDER_RESULT({ isError: false, messageError: '', purchaseReference: res.data.idpin });
					this.handleNextStep();
					this.$toast.success(this.$t('steppersale.correctprocess'));
				})
				.catch((err) => {
					const errorMessage = err.response.data.message || err.message;
					this.SET_ORDER_RESULT({ isError: true, messageError: errorMessage, purchaseReference: '' });

					this.$toast.error(errorMessage);
					this.handleNextStep();

					console.log(err);
				})
				.finally(() => {
					this.SET_PANEL_DISABLED({
						panel1disabled: true,
						panel2disabled: true,
						panel3disabled: true,
						panel4disabled: false
					});

					this.paymentLoading = false;
				});
		},
		handlePayment() {
			const body = this.prepareProccesPaymentBody();
			this.paymentLoading = true;

			api.externalSale
				.performSale({ body })
				.then((res) => {
					// const url = res.data.url;

					this.paymentForm.URL = res.data.url;
					this.paymentForm.PARAMETERS = res.data.parameters;
					this.paymentForm.SIGNATURE = res.data.signature;
					this.paymentForm.IDPASARELA = res.data.idpasarela;
					this.paymentForm.IDPIN = res.data.idpin;
					this.paymentForm.CANT = res.data.cant;
					this.paymentForm.DESCRIP = res.data.descrip;
					this.paymentForm.EVENTO = res.data.evento;
					this.paymentForm.ANYO = res.data.anyo;

					console.log(res.data);


				})
				.then(() => {
					window.localStorage.setItem('FV_EVENT_DATA', JSON.stringify(this.getEvent));
					window.localStorage.setItem('FV_EVENT_IMG', JSON.stringify(this.getEventImage));
					window.localStorage.setItem('FV_SALE_DATA', JSON.stringify(this.getTicketsToSale));
				})
				//for some reasan we can't call formulariodepago before 1 s...
				.then(() => new Promise((resolve) => setTimeout(resolve, 1000)))
				.then(() => {
					console.log(document.getElementById('formulariodepago'));

					const sendSubmit = () => document.getElementById('formulariodepago').submit();
					sendSubmit();
				})
				.catch((err) => {
					const errorMessage = err.response.data.message || err.message;
					this.$toast.error(errorMessage);

					console.log(err);
				})
				.finally(() => {
					this.SET_PANEL_DISABLED({
						panel1disabled: true,
						panel2disabled: true,
						panel3disabled: true,
						panel4disabled: false
					});

					this.paymentLoading = false;
				});
		},
		handleSelectedBuyer(selectedBuyer) {
			this.selectedBuyer = selectedBuyer;
		},
		handleLoginSuccesfull() {
			this.loginIsNeeded = false;
			this.disableAllPanels = false;
		},
		handlerPanelDynamicForm() {
			const notExistSelectedRol = this.getSelectedRol === undefined || this.getSelectedRol === null || this.getSelectedRol === '';

			if (this.loginRequired && (this.getIsAnonymus || notExistSelectedRol)) {
				this.loginIsNeeded = true;
				this.disableAllPanels = true;
			}
		},
		handleNextStep() {
			const acualStep = this.activePanel || 0;
			this.activePanel = acualStep + 1;
		},
		handleLoginTransaction(isActiveLoginTransaction) {
			this.disableAllPanels = isActiveLoginTransaction;
		}
	},
	computed: {
		...mapGetters([
			'getTicketsToSale',
			'loginRequired',
			'getIsAnonymus',
			'getSelectedRol',
			'getFirstSaleData',
			'getLogin',
			'isFree',
			'getEvent',
			'getEventImage',
			'getPanels',
			'getActivePanel'
		])
	}
};
</script>

<style scoped>
.first-panel {
	border-radius: 8px;
	position: static;
}
</style>
